export default function CTABanner() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20modern%20ecommerce%20shopping%20concept%20with%20an%20open%20laptop%20beside%20neatly%20arranged%20fashion%20accessories%20including%20a%20tan%20leather%20bag%20and%20minimal%20jewelry%20on%20a%20light%20cream%20marble%20desk%20surface%2C%20soft%20golden%20afternoon%20sunlight%20streaming%20through%20floor%20to%20ceiling%20windows%20creating%20beautiful%20warm%20highlights%20and%20gentle%20shadows%2C%20sophisticated%20lifestyle%20product%20photography%2C%20rich%20amber%20beige%20and%20cream%20tones%2C%20airy%20spacious%20interior%20with%20subtle%20greenery%20in%20background%2C%20aspirational%20contemporary%20aesthetic%20with%20organic%20textures%20and%20refined%20composition&width=1800&height=800&seq=cta-v2-2026&orientation=landscape"
          alt="Sugargoo Spreadsheet shopping experience"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/75 to-foreground-900/40"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-4">
          Ready to Start Shopping Smarter?
        </h2>
        <p className="text-sm md:text-base text-background-50/80 max-w-lg mx-auto mb-8">
          Join thousands of savvy shoppers using Sugargoo Spreadsheet to discover trending products, compare prices, and save on international shipping.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Sugargoo Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-background-50 text-foreground-900 rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}